import React, { useState } from "react";
import styles from "./styles/AssetDashboard.module.css";

/*
  The chrome every numbered section of the report wears: the navy bar with its
  number and title, and a body that folds away behind its own toggle.

  `startOpen` is per section because the design does not show them all the same
  way — Wealth Summary is drawn collapsed, its toggle reading "Extend", while
  the others are open and read "Hide".
*/
function SectionShell({
  sectionKey,
  number,
  title,
  openLabel,
  closedLabel,
  startOpen = true,
  children,
}) {
  const [open, setOpen] = useState(startOpen);
  return (
    /*
      `data-report-section` is the section's name in the DOM, and the only way
      the PDF has of leaving one out: the chapter picker hands the capture a
      selector built from these, and the clone drops what it matches. A class
      would not do — CSS Modules would hash it out of reach of a selector built
      at runtime.
    */
    <section className={styles.section} data-report-section={sectionKey}>
      <header className={styles.section_head}>
        <span className={styles.section_num}>{number}</span>
        <h2 className={styles.section_title}>{title}</h2>
        <button
          type="button"
          className={styles.section_toggle}
          aria-expanded={open}
          onClick={() => setOpen((prev) => !prev)}
        >
          {open ? openLabel : closedLabel}
        </button>
      </header>
      {/*
        Always rendered, hidden with CSS rather than dropped from the tree.

        `{open && ...}` meant a collapsed section did not exist in the DOM, so
        printing the report silently omitted whatever the reader had folded
        away. Nothing in a section measures itself, so mounting one that is not
        on screen costs nothing and the print stylesheet can simply reveal it.
      */}
      <div
        className={`${styles.section_body} ${open ? "" : styles.section_closed}`}
      >
        {children}
      </div>
    </section>
  );
}

export default SectionShell;
